module.exports = __webpack_public_path__ + "img/dscvry_logo-grey.205c4a95.png";